import { FCAData } from "@/mocks/fca";

interface Props {
  data: FCAData;
}

export default function TreeBotanicalCard({ data }: Props) {
  const bot = data.dadosBotanicos;

  return (
    <div className="bg-white rounded-card border border-background-200/70 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 font-heading mb-4 flex items-center gap-2">
        <i className="ri-leaf-line text-primary-500"></i>
        Dados Botânicos
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
        <BotField label="Tipo de Indivíduo" value={bot.tipoIndividuo} icon="ri-plant-line" />
        <BotField label="Nome Popular" value={bot.nomePopular} icon="ri-edit-line" />
        <BotField label="Família Botânica" value={bot.familiaBotanica} icon="ri-git-branch-line" />
        <BotField label="Origem" value={bot.origem} icon="ri-earth-line" />
        <BotField label="Porte" value={bot.porte} icon="ri-arrow-up-down-line" />
        <BotField label="Estágio de Desenvolvimento" value={bot.estagioDesenvolvimento} icon="ri-seedling-line" />
      </div>

      {/* Scientific name */}
      <div className="mt-4 p-3 bg-background-50 rounded-lg border border-background-200/70">
        <p className="text-[11px] text-foreground-500 uppercase tracking-wide mb-1">Nome Científico</p>
        <p className="text-sm text-foreground-800 italic">{bot.nomeCientifico}</p>
      </div>

      {/* Observations */}
      {bot.observacoesBotanicas && (
        <div className="mt-3 p-3 bg-accent-50/30 rounded-lg border border-accent-200/50">
          <p className="text-[11px] text-accent-600 uppercase tracking-wide mb-1 flex items-center gap-1">
            <i className="ri-information-line"></i>
            Observações Botânicas
          </p>
          <p className="text-sm text-foreground-700 leading-relaxed">{bot.observacoesBotanicas}</p>
        </div>
      )}
    </div>
  );
}

function BotField({ label, value, icon }: { label: string; value: string; icon: string }) {
  return (
    <div className="flex items-start gap-2.5">
      <span className="w-8 h-8 rounded-md bg-primary-50 flex items-center justify-center shrink-0 mt-0.5">
        <i className={`${icon} text-primary-600 text-sm`}></i>
      </span>
      <div>
        <p className="text-[11px] text-foreground-500 uppercase tracking-wide">{label}</p>
        <p className="text-sm text-foreground-900 font-medium">{value}</p>
      </div>
    </div>
  );
}